module.exports = __webpack_public_path__ + "static/media/sassy logo3.e7766242.jpg";